<template>
  <div class="calendar">
    <v-row justify="center">
      <v-col class="pb-0" cols="12" align="center">
        <div class='mt-5 mb-2 title d-flex justify-center'>
          <span><v-img width="30px" :src='schoolLogoUrl' /></span>
          <span v-if="$i18n.locale=='tc'" class='ml-2'> {{ schoolChiName }} </span>
          <span v-else class='ml-2'> {{ schoolName }} </span>
        </div>
      </v-col>
      <v-col class="mx-3" align="center">
        <v-sheet max-width="1200px">
          <v-select v-if="$i18n.locale=='tc'"
            :items="api.experiments"
            item-text="experiment_set_chi"
            item-value="experiment_set"
            v-model="selected_experiment"
            label="請選擇實驗組"
            no-data-text="沒有適用的實驗組"
            @change="changeExperimentSet(selected_experiment);"
          ></v-select>
          <v-select v-else
            :items="api.experiments"
            item-text="experiment_set"
            item-value="experiment_set"
            v-model="selected_experiment"
            label="Select an experiment set"
            no-data-text="No Experiment Available"
            @change="changeExperimentSet(selected_experiment);"
          ></v-select>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col class="py-0" cols="12" align="center">
        <v-sheet heigth="64px" max-width="1200px">
          <v-toolbar flat>
            <v-btn fab text small color="grey darken-2" @click="$refs.calendar.prev()">
              <v-icon>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="$refs.calendar.next()">
              <v-icon>
                mdi-chevron-right
              </v-icon>
            </v-btn><v-btn outlined class="mr-4" color="grey darken-2" @click="setToday" :disabled="focus==''">
              {{ $t("booking.calendar.today") }}
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-chip class="ma-2" label dark color="green">{{ $t("booking.calendar.tip_reserved") }}</v-chip>
            <v-chip class="ma-2 px-5" label dark color="grey">{{ $t("booking.calendar.tip_suspended") }}</v-chip>
            <v-chip class="ma-2" label dark color="amber darken-2">{{ $t("booking.calendar.tip_maintenance") }}</v-chip>
          </v-toolbar>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col col=12 align="center">
        <v-sheet max-width="1200px">
          <v-calendar              
            ref="calendar"
            v-model="focus"
            :weekdays=weekday
            type="week"
            :locale="localeArr[$i18n.locale]"
            :interval-format="intervalFormat"
            :events="events"
            event-overlap-mode="column"
            :event-overlap-threshold="30"
            :event-color="getEventColor"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="getEvents"
          >
          <template v-slot:event="{ event }">
            {{event.name}}
            <br>
            {{ event.start_time }} - {{ event.end_time }}
          </template>
          </v-calendar>
          <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-btn icon @click="selectedOpen = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="pl-0">{{ selectedEvent.name }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <span v-if="user.user_level=='ADMIN' || user.user_level=='TEACHER'"  v-html="selectedEvent.details"></span>
                <span v-else-if="user.user_level=='STUDENT'"  v-html="selectedEvent.details_users"></span>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment';
import { api_dds_booking } from "@/services/dds/api_dds_booking";
const apiDDSBooking = new api_dds_booking(process.env.VUE_APP_BASE_URL);
export default {
  props: ["schoolName", "schoolChiName", "schoolLogoUrl"],
  name: "Calendar",
  data: function () {
    return {
      user: {
        user_level: "",
      },
      localeArr: {"tc": 'zh-hk', "en": 'en'},
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      focus: '',
      type: 'month',
      mode: 'stack',
      weekday: [0, 1, 2, 3, 4, 5, 6],
      events: [],
      color_index:['RESERVED', 'SUSPENDED', 'MAINTENANCE', 'PASSED'],
      colors: ['green', 'grey', 'amber darken-2'],
      colors_passed: ['green lighten-4', 'grey lighten-2', 'amber lighten-3'],
      slots:[],
      api:{
        experiments:[],
      },
      calendar: {
        start: {},
        end: {},
      },
      school_code: "",
      experiment: "All",
      equipment_id: "All",
      selected_experiment: "All - All",
      show_all: false,
    };
  },
  mounted: function () {
    var self = this;
    self.school_code = self.$route.params.school_code;
    self.user.user_level = self.$cookies.get("user_level");
    if( self.user.user_level=="TEACHER" ||  self.user.user_level=="ADMIN" ){
      self.show_all = true;
    }
    else {
      self.show_all = false;
    }
    console.log();
    self.getSchoolOpenedExperiment();
    
      self.selected_experiment = "All - All";
  },  
  computed: {
    
  },
  methods: {    
    getSchoolOpenedExperiment(){
      var self = this;
      apiDDSBooking.getSchoolOpenedExperiment(self.school_code, self.show_all)
      .then((response) => {          
          self.api.experiments = response.experiments;
          self.api.experiments.unshift(
            {
              "school": self.school_code,
              "experiment": "All",
              "experiment_chi": "全部",
              "equipment_id": "All",
              "equipment_id_chi": "全部",
              "experiment_set": "All - All",
              "experiment_set_chi": "全部 - 全部"
            }
          )
      });
    },
    changeExperimentSet(experiment_set){
      var self = this;
      let split = experiment_set.split(" - ");
      self.experiment = split[0];
      self.equipment_id = split[1];
      self.getEvents(self.calendar);
      
      self.$refs.calendar.checkChange()
    },
    intervalFormat(interval) {
      return interval.time;
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    getEvents ({ start, end }) {
      var self = this;
        self.calendar.start = start;
        self.calendar.end = end;
        const events = [];        
        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        let experiment = self.experiment;
        let equipment_id = self.equipment_id;
        apiDDSBooking.getSchoolWeekBookings(self.$route.params.school_code, experiment, equipment_id, min, max)
        .then((response) => {
          if (response.status == "success") {
            for (let i = 0; i < response.bookings.length; i++) {
              let booking = response.bookings[i];
              let has_entered = "";
              if(booking.has_entered == "1"){
                has_entered = "Y";
              }
              let color = "";
              if(booking.passed==true){
                color=self.colors_passed[self.color_index.indexOf(booking.status)]
              }
              else {
                color=self.colors[self.color_index.indexOf(booking.status)]
              }
              if(self.$i18n.locale=="tc"){
                events.push({
                  name: booking.experiment_set_chi,
                  start: booking.start_at,
                  end: booking.end_at,
                  color: color,
                  start_time: moment(booking.start_at).format('HH:mm'),
                  end_time: moment(booking.end_at).format('HH:mm'),
                  details_users:
                  "<table>\
                    <tr><td>實驗裝置:&nbsp</td><td>"+booking.experiment_set_chi+"</td></tr>\
                    <tr><td>開始:&nbsp</td><td>"+booking.start_at+"</td></tr>\
                    <tr><td>結束:&nbsp</td><td>"+booking.end_at+"</td></tr>\
                    <tr><td>狀態:&nbsp</td><td>"+booking.status_chi+"</td></tr>\
                  </table>",
                  details: 
                  "<table>\
                    <tr><td>使用者:&nbsp</td><td>"+booking.display_name+"</td></tr>\
                    <tr><td>實驗裝置:&nbsp</td><td>"+booking.experiment_set_chi+"</td></tr>\
                    <tr><td>開始:&nbsp</td><td>"+booking.start_at+"</td></tr>\
                    <tr><td>結束:&nbsp</td><td>"+booking.end_at+"</td></tr>\
                    <tr><td>狀態:&nbsp</td><td>"+booking.status_chi+"</td></tr>\
                    <tr><td>已進入:&nbsp</td><td>"+has_entered+"</td></tr>\
                  </table>"
                })
              }else {
                events.push({
                  name: booking.experiment_set,
                  start: booking.start_at,
                  end: booking.end_at,
                  color: color,
                  start_time: moment(booking.start_at).format('HH:mm'),
                  end_time: moment(booking.end_at).format('HH:mm'),                  
                  details_users:
                  "<table>\
                    <tr><td>Experiment Set:&nbsp</td><td>"+booking.experiment_set+"</td></tr>\
                    <tr><td>From:&nbsp</td><td>"+booking.start_at+"</td></tr>\
                    <tr><td>To:&nbsp</td><td>"+booking.end_at+"</td></tr>\
                    <tr><td>Status:&nbsp</td><td>"+booking.status+"</td></tr>\
                  </table>",
                  details: 
                  "<table>\
                    <tr><td>User:&nbsp</td><td>"+booking.display_name+"</td></tr>\
                    <tr><td>Experiment Set:&nbsp</td><td>"+booking.experiment_set+"</td></tr>\
                    <tr><td>From:&nbsp</td><td>"+booking.start_at+"</td></tr>\
                    <tr><td>To:&nbsp</td><td>"+booking.end_at+"</td></tr>\
                    <tr><td>Status:&nbsp</td><td>"+booking.status+"</td></tr>\
                    <tr><td>已進入:&nbsp</td><td>"+has_entered+"</td></tr>\
                  </table>"
                })
              }
            }
            self.events = events;
          } else {
            self.events = [];
            //alert(response.message+"asda");
          }
        });        
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>